import React from 'react';

import { useCommonOptionsStore } from '../store';

import { langs } from './langs';

import type { LocaleType } from '../@types';

export const useTranslations = (locale: LocaleType) => {
  const labels = useCommonOptionsStore(state => state.labels);

  const translations = React.useMemo(() => {
    const defaults = langs.en;
    const shortLocale = locale?.split(/_|-/).shift() || 'en';
    const data = langs[shortLocale] || {};
    const customLabels = (labels || {})[shortLocale] || {};

    return {
      ...defaults,
      ...data,
      ...customLabels,
    };
  }, [locale, labels]);

  const t = React.useCallback(
    (key: string) => translations[key] || key,
    [translations],
  );

  return [t];
};
